import qs from 'qs';
import BaseHttp from '../../../plugins/baseHttp';

const get = () => {
  return BaseHttp.get('/coupon-packages',);
};

const enable = (id,) => {
  return BaseHttp.patch(`/coupon-packages/${id}/enable`,);
};

const disable = (id,) => {
  return BaseHttp.patch(`/coupon-packages/${id}/disable`,);
};

const save = (couponPackage,) => {
  return BaseHttp.post('/coupon-packages', couponPackage,);
};

const update = (id, couponPackage,) => {
  return BaseHttp.patch(`/coupon-packages/${id}`, couponPackage,);
};

const getCities = ({franchises, size, from,},) => {
  const queryObj = {
    size: size,
    from: from,
  };

  const query = `/address/cities/franchises?id=${franchises}&${qs.stringify(queryObj,)}`;

  return BaseHttp.get(query,);
};

export default{
  get,
  enable,
  disable,
  save,
  update,
  getCities,
};
